import {useTranslation} from "react-i18next";
import {typeStateCategories} from "../Layout";
import React from "react";
import {data} from "../Store/Data";
import {FormDataReducer} from "./FormControl";
import FormFields from "./FormFields";
import SubmitButton from "./SubmitButton";

interface FormProps extends typeStateCategories {
	selectedShortName: string;
	formDispatcher: React.Dispatch<FormDataReducer>;
}

export const Form = (props: FormProps) => {
	const {state, selectedShortName} = props;
	const [category] = state;
	const {t} = useTranslation();

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		const formEl = e.target as HTMLFormElement,
			formData = new FormData(formEl),
			params = new URL(window.location.href).searchParams;

		const bonus = formData.get('bonus') as string;
		formData.delete('bonus');
		const formParams = new URLSearchParams(formData as any).toString()

		let url = 'https://www.visit-x.net/?vxpAutoFlow=Signup&' + formParams + '&' + params.toString() + (bonus ? '&option=' + bonus : '');
		window.location.href = url;
	}

	return (
		<form id={'form_container'} className="form box margin-vertical-2" onSubmit={handleSubmit}>
			<input hidden name="version" value={data('vxApiVersion').asString()}/>
			<input hidden name="lpId" value={data('lpId').asString()}/>
			<input hidden name="pfm" value={data('pfm').asString()}/>
			<FormFields selectedShortName={selectedShortName} category={category}/>
			<SubmitButton category={category}/>
			<div className="grid-3-col margin-top-1">
				<div className="flex-align-center shield-item gap-1">
					<span className="icon--ri map-pin-line"></span>
					<small className="text-align-center">{t('Deutsches Unternehmen')}</small>
				</div>
				<div className="flex-align-center shield-item gap-1">
					<span className="icon--ri secure-payment-line"></span>
					<small className="text-align-center">{t('Geprüfte Zahlungen')}</small>
				</div>
				<div className="flex-align-center shield-item gap-1">
					<span className="icon--ri customer-service-line"></span>
					<small className="text-align-center">{t('Support auf Deutsch')}</small>
				</div>
			</div>
		</form>
	)
}
